import { render, staticRenderFns } from "./ChannelDetail.vue?vue&type=template&id=0741244a&scoped=true"
import script from "./ChannelDetail.vue?vue&type=script&lang=js"
export * from "./ChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./ChannelDetail.vue?vue&type=style&index=0&id=0741244a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0741244a",
  null
  
)

export default component.exports